import React, { memo, useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UiIcon from 'components/Shared/Common/Icon';
import { injectIntl } from 'react-intl';

import DrawerNotifications from 'components/Shared/Drawers/Notifications';
import { Tooltip } from 'antd';

import { connect } from 'react-redux';
import { selectors } from '@amplement/backend-connector';
import { NOTIFICATION_CATEGORIES } from 'const/notification';
import CatchError from 'components/CatchError';
import Badge from 'components/Shared/Common/Badge';
import { hashParameters } from 'const/url';
import { setHashParameter, removeAllHashParameters, hasHashParameter } from 'utils/url';
import { StyledBellButton } from 'components/Shared/style';

const BellNotification = ({ onClick, notificationCount = 0, intl }) => (
    <StyledBellButton 
        useRef="bellButton"
        onClick={onClick}
    >
        <Tooltip 
            placement="bottom" 
            title={intl.formatMessage({ id: 'global.button.notifications' })}
        >
            <div className={classNames(
                's-icon-content',
                { active: !!notificationCount }
            )}>
                <Badge maxCount={999} count={notificationCount} offset={[0, -3]} size="small">
                    <div className="icon-wrapper">
                        <UiIcon
                            iconName="Bell"
                        />
                    </div>
                </Badge>
            </div>
        </Tooltip>
    </StyledBellButton>
);

BellNotification.propTypes = {
    onClick: PropTypes.func,
    intl: PropTypes.any.isRequired,
    notificationCount: PropTypes.number
};

const BellNotificationComponent =  memo(injectIntl(BellNotification));

const BellNotificationContainer = (props) => {
    const {
        TriggerComponent = BellNotificationComponent,
        notificationCount,
    } = props;
    const [isDrawerOpened, setIsDrawerOpened] = useState();

    useEffect(() => {
        if (hasHashParameter(hashParameters.BELL)) {
            setIsDrawerOpened(true);
        }
    }, []);

    const handleCloseDrawer = useCallback(() => {
        removeAllHashParameters();
        setIsDrawerOpened(false);
    }, [setIsDrawerOpened]);

    const handleToggleDrawer = useCallback(() => {
        const hasHash = hasHashParameter(hashParameters.BELL);
        if (!isDrawerOpened && !hasHash) {
            setHashParameter(hashParameters.BELL);
        } else if (hasHash) {
            removeAllHashParameters();
        }
        setIsDrawerOpened(!isDrawerOpened);
    }, [setIsDrawerOpened, isDrawerOpened]);

    return (
        <CatchError>
            <DrawerNotifications onClose={handleCloseDrawer} isOpen={isDrawerOpened} />
            <TriggerComponent
                onClick={handleToggleDrawer}
                notificationCount={notificationCount}
            />
        </CatchError>
    );
}

BellNotificationContainer.propTypes = {
    TriggerComponent: PropTypes.any
};

export const Component = memo(BellNotificationContainer);

const mapStateToProps = state => ({
    notificationCount: selectors.notifications.getUnreadNotificationCountByCategorySelector(state, NOTIFICATION_CATEGORIES.QUICKACTIONS),
});


export default connect(mapStateToProps, null)(Component);

